<template>
  <div v-show="true" class="w-full flex flex-col">

    <div class="grid grid-cols-6 gap-1">
      <div class="ml-10 mb-5">
        <select v-model="selectedLayer" class="block w-full pl-3 pr-10 py-2 border rounded">
            <option disabled value="">{{$t('selectlayer')}}</option>
            <option v-for="option in layeroptions" v-bind:value="option">
                {{ option.Title }}
            </option>
        </select>
      </div>
      <div>
        <select v-model="selectedComponent" class="block w-full pl-3 pr-10 py-2 border rounded">
            <option disabled value="">{{$t('selectcomponent')}}</option>
            <option v-for="c in Components" v-bind:value="c.Component.Text">
                {{ c.Component.Text }}
            </option>
        </select>
      </div>
      <div class="ml-5">
        <vue-ctk-date-time-picker
            v-model="dateRangeTo"
            :no-value-to-custom-elem="true"
            input-size="sm"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            label="Select to time"
            button-now-translation="Now"
            color="#7fa99b"
            :no-clear-button="true"
            :no-header="true" :minute-interval=60
            >
            <l-input v-model="dateRangeTo" type="text" placeholder>
                <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
                </template>
            </l-input>
        </vue-ctk-date-time-picker>
      </div>
      <div class="ml-5"><l-button type="success" @click="onClick"> {{$t('loadmap')}}</l-button></div>
      <div class="ml-5"><p>{{error}}</p></div>
      <div class="ml-5"><l-button @click="showanimate">{{ $t('animatemaps')}} <font-awesome-icon v-bind:icon="animateopen ? 'chevron-up' : 'chevron-down' "/> </l-button></div>
    </div>
    <div v-show="animateopen" class="mb-5 grid grid-cols-6 gap-1">
      <div class="ml-10">
        <vue-ctk-date-time-picker
          v-model="animFromDate"
          :no-value-to-custom-elem="true"
          input-size="sm"
          format="YYYY-MM-DD HH:mm"
          formatted="YYYY-MM-DD HH:mm"
          label="Select to time"
          button-now-translation="Now"
          color="#7fa99b"
          :no-clear-button="true"
          :no-header="true" :minute-interval=60
          >
          <l-input v-model="animFromDate" type="text" placeholder>
              <template slot="prefix">
              <font-awesome-icon icon="clock" class="text-base text-gray-500" />
              </template>
          </l-input>
        </vue-ctk-date-time-picker>
      </div>
      <div class="ml-5">
        <vue-ctk-date-time-picker
          v-model="animToDate"
          :no-value-to-custom-elem="true"
          input-size="sm"
          format="YYYY-MM-DD HH:mm"
          formatted="YYYY-MM-DD HH:mm"
          label="Select to time"
          button-now-translation="Now"
          color="#7fa99b"
          :no-clear-button="true"
          :no-header="true" :minute-interval=60
          >
          <l-input v-model="animToDate" type="text" placeholder>
              <template slot="prefix">
              <font-awesome-icon icon="clock" class="text-base text-gray-500" />
              </template>
          </l-input>
        </vue-ctk-date-time-picker>
      </div>
      <div class="ml-5" v-if="!playingAnim"><l-button type="success" @click="onAnimClick"> {{$t('playanimation')}}</l-button></div>
      <div class="ml-5" v-if="!playingAnim"><l-button type="success" @click="onClearAnimClick"> {{$t('clearanimation')}}</l-button></div>
      <div class="ml-5" v-if="playingAnim"> {{$t('animationrunning')}}</div>
    </div>
    <div class="ml-10 " v-for="extent in selectedLayer.Extent" :key="extent.Name">
      <span v-if="extent.Name === 'time'">  {{$t('daterangeavl')}} {{selectedLayer.Title}} : {{ extent.Text }}</span>
    </div>
  </div>
</template>

<script>

import GeoserverService from "@/helpers/apiservices/geoserver/geoserver.service";
import Notify from "@/helpers/notify";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import * as moment from "moment";
import { LSelect, LOption, LButton, LInput, LCheckbox } from "@/components/forms";

export default {
name: 'LLayerSelection',
props: [
      "playingAnim"
  ],
data() {
  return {
    selectedLayer: "",
    selectedComponent: "",
    layeroptions: [],
    animFromDate: moment().subtract(24,"hours").format("YYYY-MM-DD HH:00"),
    animToDate: moment().format("YYYY-MM-DD HH:00"),
    dateRangeTo: moment().format("YYYY-MM-DD HH:00"), 
    error: "",
    animateopen: false,
  };
},
components: {
  LInput,
  LSelect,
  LOption,
  LButton,
  LCheckbox,
  VueCtkDateTimePicker
},
mounted() {
  //Notify.loadData(null, this.loadInitialData);
  this.loadInitialData();
},
methods: {
  async loadInitialData() {
    try  {
      this.layeroptions = await GeoserverService.layers();
    }
    catch (error) {
      console.error(error);
    }
  },
  onClick : function(id) {
    if(this.validated()){
      this.$emit("click", this.selections(moment(this.dateRangeTo).utc().toISOString(), moment(this.dateRangeTo).utc().toISOString(), "single"));
    }
  },
  onAnimClick : function(id) {
     if(this.validated()){
      this.$emit("click",this.selections(moment(this.animFromDate).utc().toISOString(), moment(this.animToDate).utc().toISOString(), "animation")); 
    }
  },
  onClearAnimClick : function(id) {
     if(this.validated()){
      this.$emit("click",this.selections(moment(this.animFromDate).utc().toISOString(), moment(this.animToDate).utc().toISOString(), "clear")); 
    }
  },
  selections : function (from, to, filtering){
    return {
      layer: this.selectedLayer.Name,
      component: this.selectedComponent,
      from: from, 
      to: to,
      filtering : filtering,
      latlonboundingbox: this.selectedLayer.LatLonBoundingBox,
      defaultstyle: this.selectedLayer.Style.Name
    }
  },
  validated: function(){
    this.error = "";
    if(!this.selectedLayer.Name){this.error = "Please select a layer"; return false;}
    else if(!this.selectedComponent){this.error = "Please select component"; return false}
    else
      return true;
  },
  showanimate : function() {
    this.animateopen = !this.animateopen;
  },
},
computed:{
    Components: function(){
        if(this.selectedLayer.Dimension){
          var compExtent = this.selectedLayer.Dimension.find(e => e.Name === 'COMPONENT');
          var compsliced = compExtent.Text.split(',');
          var Components = [];
          compsliced.forEach(e => {
              Components.push({"Component" : {"Text": e}});
          });
          return Components;
        } 
        else return {};
    }
}
};
</script>

